import { useRecoilValue } from "recoil";
import { accessTokenAtom } from "../recoil/auth";
import LoginPage from "../page/Login/LoginPage";

const requiredAuth = (Component) => {
  return (props) => {
    const isLoggedIn = useRecoilValue(accessTokenAtom);
    if (!isLoggedIn) {
      return <LoginPage />;
    }
    return <Component {...props} />;
  };
};

export default requiredAuth;
